import { Icon } from './index'

export const ImagePlaceholder: Icon = ({
	disabled,
	className,
}: {
	disabled?: boolean
	className?: string
}) => (
	<svg
		className={disabled ? 'stroke-gray-400' : className}
		width="56"
		height="56"
		viewBox="0 0 56 56"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="56" height="56" rx="8" fill="#E0E0E0" />
		<path
			opacity="0.4"
			d="M34.2342 30.999L32.2867 26.4444C31.932 25.6106 31.4031 25.1377 30.7996 25.1066C30.2022 25.0755 29.6236 25.4924 29.1818 26.2888L27.9996 28.4106C27.7507 28.8586 27.396 29.1262 27.0102 29.1573C26.6182 29.1946 26.2262 28.9893 25.9089 28.5848L25.772 28.4106C25.3302 27.8568 24.7827 27.5893 24.2227 27.6453C23.6627 27.7013 23.1836 28.087 22.8662 28.7155L21.7898 30.8622C21.404 31.6399 21.4413 32.5422 21.8956 33.2764C22.3498 34.0106 23.14 34.4524 24.0049 34.4524H31.9445C32.7782 34.4524 33.556 34.0355 34.0165 33.3386C34.4893 32.6417 34.564 31.7644 34.2342 30.999Z"
			fill="#AEAEAE"
		/>
		<path
			d="M24.8697 25.7476C26.0312 25.7476 26.9728 24.806 26.9728 23.6445C26.9728 22.483 26.0312 21.5414 24.8697 21.5414C23.7082 21.5414 22.7666 22.483 22.7666 23.6445C22.7666 24.806 23.7082 25.7476 24.8697 25.7476Z"
			fill="#AEAEAE"
		/>
	</svg>
)
